import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { EnvironmentConfiguration } from 'src/app/environment/services/environment.configuration';
import { MsalService } from 'src/app/msal';

export interface UserAccountModel{
    environment?: string,
    homeAccountId?: string,
    idTokenClaims?: {
      roles?: any
    },
    localAccountId?: string,
    name?: string,
    tenantId?: string,
    username?: string
}
@Injectable({
  providedIn: 'root'
})
export class UserAccountStoreService {
  account: any = {
    environment: '',
    homeAccountId: '',
    idTokenClaims: {},
    roles: [],
    localAccountId: '',
    name: '',
    tenantId: '',
    username: ''
  };
  silentSSORequest: any;
  constructor(
    private readonly authService: MsalService,
    private readonly environment: EnvironmentConfiguration
    ) {
      this.silentSSORequest = {
        scopes: ['openid', 'offline_access', `${this.environment['CLIENT_ID']}/.default`],
        forceRefresh: false
      }
    }

  public readonly userAccountBehavior = new BehaviorSubject<any>(null);
  userAccountDetails = this.userAccountBehavior.asObservable();

  isuserdetails = false;
  oldaccesstoken = '';
  setAccountDetails(data: any){
    
    if( this.oldaccesstoken !== data.idToken ){ 
      this.userAccountBehavior.next(data);
      this.oldaccesstoken = data.idToken
     
    }
    if (this.oldaccesstoken === data.idToken && this.tokenExpired(data.idToken)) { // called resfresh token and set new token
     this.refreshToken()
    }
  }

  tokenExpired(token: string) {
    const expiry = (JSON.parse(atob(token.split('.')[1]))).exp;
    return (Math.floor((new Date).getTime() / 1000)) >= expiry;
  }
  
  refreshToken(){
    this.authService.acquireTokenSilent(this.silentSSORequest)
    .subscribe({
      next: (result: any) => {   
        this.userAccountBehavior.next(result);
        this.oldaccesstoken = result.idToken
      },
      error: () => this.authService.acquireTokenRedirect(this.silentSSORequest)
    });
  }

  getAccountDetails(userAccountDetails){
   
    if(userAccountDetails !== null){
      const accountDetails = userAccountDetails as UserAccountModel;
      const roles = accountDetails?.idTokenClaims?.roles
      const accountDetailsObj = {
        environment: accountDetails?.environment,
        homeAccountId: accountDetails?.homeAccountId,
        idTokenClaims: accountDetails?.idTokenClaims,
        roles: roles,
        localAccountId: accountDetails?.environment,
        name: accountDetails?.name,
        tenantId: accountDetails?.tenantId,
        username: accountDetails?.username
      };
      this.account = accountDetailsObj;
      
    }
    return this.account
  }
  
}